export default {
    new: {
      value: 'new',
      name: 'Ocena formalna',
    },
    verifying: {
      value: 'verifying',
      name: 'Ocena merytoryczna',
    },
    verified: {
      value: 'verified',
      name: 'Zweryfikowany',
    },
    rejected: {
      value: 'rejected',
      name: 'Odrzucony',
    },
    draft: {
      value: 'draft',
      name: 'Roboczy',
    },
  };


// WEBPACK FOOTER //
// ./src/components/budget/applicationStatuses.js